import React, { InputHTMLAttributes, useEffect, useState } from 'react';
import './template.css';


import html2pdf from 'html2pdf.js';
import { Col, Row } from 'reactstrap';
import logo from "../../assets/images/dofy-logo-blue.png"
import OrderDocumentInfo from './OrderDocumentInfo'
import Questionarie from './Questionarie'
import { useParams } from 'react-router-dom';
import { ID_EncryptionKey, findedLocation } from '../../helpers/Helper'
import moment from 'moment';
import numberToWords from 'number-to-words';


var CryptoJS = require("crypto-js");


interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    orderSummaryInfo: any,
    reRender: any,
    showEdit: any
    isCancel?: boolean,

}
function Template({ orderSummaryInfo, reRender, showEdit }: inputProps) {

    const { encryptedId } = useParams<any>();

    const convertToText = (value) => {
        const number = parseFloat(value);
        return isNaN(number) ? 'Invalid number' : numberToWords.toWords(number);
    };

    // const downloadPDF = () => {
    //     const element = document.getElementById('content'); // 'content' is the id of the HTML element you want to convert
    //     html2pdf(element);
    // };

    return (
        <div id="content">
            <div className="card" style={{ marginLeft: "60px", background: 'white' }}>
                <div className="pth-container">
                    {/* <button onClick={downloadPDF}>Invoice</button> */}
                    {/* Top Section */}
                    <Row className=" text-dofy ">
                        <Col xl={5} className='mt-4'>
                            <h5>Order: {orderSummaryInfo.OrderCode}</h5>
                        </Col>
                        <Col xl={4} className='mt-4'>
                            <h5>DeviceType:{orderSummaryInfo.ProductTypeName} </h5>
                        </Col>
                        <Col xl={3}  >
                            <img style={{ height: '40px' }} src={logo} alt="logo" />
                        </Col>
                    </Row>

                    {/* Details Section */}
                    <div className='mt-3'>
                        <table>
                            <thead className='text-dofy'>
                                <tr>
                                    <th>Seller Details:</th>
                                    <th>Assignee Details:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Name:</td>
                                                    <td>{orderSummaryInfo.UserName}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Phone :</td>
                                                    <td>{orderSummaryInfo.UserMobile}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Address:</td>
                                                    <td>{orderSummaryInfo.Appointment.Address}, {orderSummaryInfo.Appointment.AppointmentCity} - {orderSummaryInfo.Appointment.AppointmentPincode}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Name:</td>
                                                    <td>{orderSummaryInfo.AssigneeDetails.AssigneeName}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Phone:</td>
                                                    <td>{orderSummaryInfo.AssigneeDetails.Mobile}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Email:</td>
                                                    <td>{orderSummaryInfo.AssigneeDetails.Email}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table>
                            <thead className='text-dofy'>
                                <tr>
                                    <th>Device Details:</th>
                                    <th>Price Details:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Brand:</td>
                                                    <td>{orderSummaryInfo.BrandMasterName}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Model:</td>
                                                    <td>{orderSummaryInfo.SeriesModelName}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Variant:</td>
                                                    <td>{orderSummaryInfo.ModelVariantName}</td>
                                                </tr>
                                                {orderSummaryInfo.OrderSpecificationsList.map((val, i) => (
                                                    <tr key={i}>
                                                        <td className='font-size-13 fw-bold'>IMEI({i + 1}) :</td>
                                                        <td>{val.IMEINumber}</td>
                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </table>
                                    </td>

                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Selling Price:</td>
                                                    <td>{findedLocation().CountryCode == "in" ? "Rs." : "AED."}{orderSummaryInfo.SuggestedCost.toLocaleString()}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Referral Bonus:</td>
                                                    <td>{findedLocation().CountryCode == "in" ? "Rs." : "AED."}{orderSummaryInfo.ReferralAmount ? "{orderSummaryInfo.ReferralAmount.toLocaleString()}" : "0"}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Adjustment:</td>
                                                    <td>{findedLocation().CountryCode == "in" ? "Rs." : "AED."}{orderSummaryInfo.Adjustment ? "{orderSummaryInfo.Adjustment.toLocaleString()}" : "0"}</td>
                                                </tr>
                                                <tr>
                                                    <td className='font-size-13 fw-bold'>Total Price:</td>
                                                    <td>{findedLocation().CountryCode == "in" ? "Rs." : "AED."}{orderSummaryInfo.FinalPaid.toLocaleString()}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <h2 className='text-dofy'>Functional Condition Details</h2>
                        <Questionarie orderSummaryInfo={orderSummaryInfo} />
                    </div>

                    <h2 className='text-dofy' style={{ marginTop: "130px" }}>Documents</h2>
                    <OrderDocumentInfo encryptedId={encryptedId} ProductTypeName={orderSummaryInfo?.ProductTypeName} isFromInvoice={true} AppointmentDate={orderSummaryInfo.Appointment.AppointmentDate}/>

                    {/* Receipt Section */}
                    <div className="pth-receipt-section">
                        <h2 className='text-dofy ' style={{ marginTop: "100px" }}>Receipt for Purchase</h2>
                        <div className="pth-receipt-table">
                           
                            <Row className='mt-5'>
                                <Col xl={7}>
                                    <div>
                                        <p>{orderSummaryInfo.UserName}</p>
                                        <p>{orderSummaryInfo.UserMobile}</p>
                                        <p>{orderSummaryInfo.Appointment.Address}, {orderSummaryInfo.Appointment.AppointmentCity} - {orderSummaryInfo.Appointment.AppointmentPincode}</p>
                                        <p>{orderSummaryInfo.OrderSpecificationsList.map((val, i) => (
                                            <tr key={i}>
                                                <td >IMEI({i + 1}) #: {val.IMEINumber}</td>
                                                <td></td>
                                            </tr>
                                        ))
                                        }</p>
                                    </div>
                                </Col>
                                <Col xl={5}>
                                    <p><text className='black fw-bold'>Service No:</text> {orderSummaryInfo.OrderCode}</p>
                                    <p><text className='black fw-bold'>Date:</text>{moment(orderSummaryInfo.Appointment.AppointmentDate).format("DD-MM-YYYY")}</p>
                                    <p><text className='black fw-bold'>Contact No:</text> {orderSummaryInfo.UserMobile}</p>

                                </Col>
                            </Row>
                            <table>
                                <thead className='black'>
                                    <tr>
                                        <th>Item Description</th>
                                        <th>Price {findedLocation().CountryCode == "in" ? "(Rs.)" : "(AED)"}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Amount</td>
                                        <td className='text-end'>{orderSummaryInfo.SuggestedCost.toLocaleString()}</td>
                                    </tr>
                                    <tr>
                                        {/* <td>{(orderSummaryInfo.Adjusment)? Adjustment:""'}</td> */}
                                        <td>{orderSummaryInfo.Adjusment ? "Adjustment" : ""}</td>
                                        <td className='text-end'>{orderSummaryInfo.Adjustment}</td>
                                    </tr>
                                    <tr>
                                        <td>{orderSummaryInfo.RequoteAmount ? "Requote Amount" : ""}</td>
                                        <td className='text-end'>{orderSummaryInfo.RequoteAmount?.toLocaleString()}</td>
                                    </tr>
                                    <tr>
                                        <td>{orderSummaryInfo.ReferralAmount ? "Referral Amount" : ""}</td>
                                        <td className='text-end'>{orderSummaryInfo.ReferralAmount?.toLocaleString()}</td>
                                    </tr>
                                    <tr className='black' >
                                        <td><strong>Total Amount</strong></td>
                                        <td className='bg text-end'><strong>{orderSummaryInfo.FinalPaid.toLocaleString()}</strong></td>
                                    </tr>
                                    <td className='text-dofy'>{convertToText(orderSummaryInfo.FinalPaid)}</td>
                                </tbody>
                            </table>
                            <p className='black fw-bold'> All payments shall be made thru Online Transfer</p>
                        </div>
                    </div>

                    <div className='text-centers mt-5'>
                        <p> * Terms and Conditions Apply *This is a computer generated receipt. *Signature not required*</p>
                        <p className='black'>   Dofy Electronics Trading L.L.C .  - All Rights Reserved</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
// }
export default Template;